module.exports = __webpack_public_path__ + "media/images/icon-mask-truck-be1770d36e660263e84084c7f9a1c6cd.png";